import * as L from 'leaflet'

const sizeOptions = (sizePx) => ({
    iconSize: [sizePx, sizePx],
    iconAnchor: [sizePx/2, sizePx/2],
    popupAnchor: [0, -sizePx]
})

export const ICON_TYPES = {
    circle: 'circle',
    image: 'image'
}

export const ICON_SIZES = {
    xs: 'xs',
    sm: 'sm',
    md: 'md',
    lg: 'lg',
    xl: 'xl'
}

const SIZE_PX = {
    xs: 8,
    sm: 16,
    md: 30,
    lg: 50,
    xl: 80
}


function makeCircleMarker(sizePx, sizeName) {
    const options = sizeOptions(sizePx)
    const baseClasses = `map-marker-circle map-marker-circle--${sizeName}`

    return {
        Default: L.divIcon({...options, className: baseClasses}),
        Active: L.divIcon({...options, className: `${baseClasses} map-marker-circle--active`}),
    }
}

function makeImageMarker(sizePx, sizeName) {
    const options = sizeOptions(sizePx)
    const baseClasses = `map-marker-circle map-marker-circle--${sizeName} map-marker-image`

    return {
        Default: (imageUrl) => L.icon({...options, iconUrl: imageUrl, className: baseClasses}),
        Active: (imageUrl) => L.icon({...options, iconUrl: imageUrl, className: `${baseClasses} map-marker-image--active`})
    }
}

const circleMarkers = {}
const imageMarkers = {}

Object.entries(SIZE_PX).forEach(([name, px]) => {
    circleMarkers[name] = makeCircleMarker(px, name)
    imageMarkers[name] = makeImageMarker(px, name)
})

export default {
    circle: ({size, active}) => circleMarkers[size][active ? 'Active' : 'Default'],
    image: ({size, active, imageUrl}) => imageMarkers[size][active ? 'Active' : 'Default'](imageUrl)
}
